<div class="mobile-multi-select-container">
    <ul class="list" role="listbox" id="mobile-multi-select-list" tabindex="-1">
        <li class="option" id="all" role="option">
            @defer {
                <finder-ra-checkbox
                    (keydownEvent)="onSelectAll($event)"
                    (clickEvent)="onClickAll($event)"
                    [checked]="multiSelect.allOption.checked"
                    (checkedChanged)="onCheckAll($event)">
                    {{multiSelect.allOption.value}}
                </finder-ra-checkbox>
            }
            <hr>
        </li>
        <li>
            <ul>
                <li *ngFor="let option of multiSelect.options"
                    class="option"
                    [id]="option.key"
                    role="option">
                    @defer {
                        <finder-ra-checkbox
                            alignment="top"
                            [checked]="option.checked"
                            [disabled]="disableOptions ? '' : null"
                            (checkedChanged)="onCheck($event, option)">
                            {{option.value}}
                        </finder-ra-checkbox>
                    }
                </li>
            </ul>
        </li>
    </ul>
    <div class="fixed-container">
        <finder-button class="action-btn" theme="primary" (click)="dismiss()">
            {{data.labels.doneButton}}
        </finder-button>
    </div>
</div>
